'use client'

import Link from 'next/link'
import { Support } from 'shared/common/Footer/components/Support/Desktop/Support'
import { Icon } from 'shared/iconpack'

import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './FooterTop.module.scss'

// TODO пока нету ссылок для внешних ресурсов (инста, сторы, тел и т.д, как появятся - проставить)
export function FooterTop() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.section}>
          <h3 className={styles.title}>Продавцам</h3>
          <ul className={styles.list}>
            <li className={styles.item}>
              <Link href={'/landing-form'}>Стать партнером</Link>
            </li>
            <li className={styles.item}>
              <Link
                target="_blank"
                rel="noopener noreferrer"
                passHref
                href={'https://crm-market.mbank.kg/auth'}
              >
                Личный кабинет
              </Link>
            </li>
            <li className={styles.item}>
              <Link
                target="_blank"
                rel="noopener noreferrer"
                passHref
                href={'https://smart.mbusiness.kg'}
              >
                Mbusiness
              </Link>
            </li>
          </ul>
        </div>
        <div className={styles.section}>
          <h3 className={styles.title}>Покупателям</h3>
          <ul className={styles.list}>
            <li className={styles.item}>
              <Support label="Поддержка" className={styles.item} />
            </li>
            <li className={styles.item}>
              <Support label="Возврат товара" className={styles.item} />
            </li>
          </ul>
        </div>
        <div className={styles.section}>
          <h3 className={styles.title}>Мы в соцсетях</h3>
          <div className={styles.instagram}>
            <Icon
              name="instagram"
              size={32}
              color={globalStyles['--icon-secondary']}
            />
            <a
              href="https://www.instagram.com/mbankkgz"
              className={styles.item}
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
          </div>
        </div>
      </div>
      <div>
        <h3 className={styles.title}>Поддержка по вашим заказам</h3>
        <p className={styles.time}>с 09:00 до 21:00</p>
      </div>
    </div>
  )
}
